<template>
  <vueCropper
    ref="vueCropperAngle"
    :img="cropperOption.img"
    :outputSize="cropperOption.size"
    outputType="png"
    :info="cropperOption.info"
    :canMove="cropperOption.canMove"
    :canMoveBox="cropperOption.canMoveBox"
    :original="cropperOption.original"
    :autoCrop="cropperOption.autoCrop"
    :fixed="cropperOption.fixed"
    :centerBox="cropperOption.centerBox"
    :infoTrue="cropperOption.infoTrue"
    :fixedBox="cropperOption.fixedBox"
    :autoCropWidth="cropperOption.autoCropWidth"
    :autoCropHeight="cropperOption.autoCropHeight"
    :high="false"
    :viewMode="1"
    @imgLoad="cropperOption.imgLoad"
  ></vueCropper>
</template>

<script>
import VueCropper from "vue-cropper";
export default {
  extends: VueCropper,
  name: "vueCropperAngle",
  props: {
    cropperOption: { type: Object, required: false },
  },
  created() {},
  methods: {
    getRef() {
      return this.$refs.vueCropperAngle;
    },
    refresh() {
      this.$refs.vueCropperAngle.refresh();
    },
    rotateStart() {
      let crop = document.getElementsByClassName("cropper-crop-box")[0];
      crop.style.minWidth = crop.style.width;
      crop.style.minHeight = crop.style.height;

      let _this = this.$refs.vueCropperAngle;
      this.cropperOption.autoCrop = false;
      _this.cropWOld = _this.cropW;
      _this.cropHOld = _this.cropH;
      _this.cropW = 0;
      _this.cropH = 0;
    },
    rotateEnd() {
      let crop = document.getElementsByClassName("cropper-crop-box")[0];
      crop.style.minWidth = "auto";
      crop.style.minHeight = "auto";

      let _this = this.$refs.vueCropperAngle;
      _this.cropW = _this.cropWOld;
      _this.cropH = _this.cropHOld;
    },
    rotate(angle) {
      this.cropperOption.rotateAngle = parseInt(angle);
      this.$refs.vueCropperAngle.rotate = parseInt(angle) / 90;
    },
    rotateLeft() {
      this.$refs.vueCropperAngle.rotateLeft();
      return;

      let cropX = this.$refs.vueCropperAngle.cropX;
      let cropY = this.$refs.vueCropperAngle.cropY;
      let cropW = this.$refs.vueCropperAngle.cropW;
      let cropH = this.$refs.vueCropperAngle.cropH;
      this.rotateStart();
      this.$refs.vueCropperAngle.rotateLeft();
      this.$nextTick(() => {
        this.rotateEnd();
        //this.$refs.vueCropperAngle.cropX = cropY;
        //this.$refs.vueCropperAngle.cropY = cropX;
        this.$refs.vueCropperAngle.cropW = cropH;
        this.$refs.vueCropperAngle.cropH = cropW;
      });
    },
    rotateRight() {
      this.$refs.vueCropperAngle.rotateRight();
      return;

      let cropX = this.$refs.vueCropperAngle.cropX;
      let cropY = this.$refs.vueCropperAngle.cropY;
      let cropW = this.$refs.vueCropperAngle.cropW;
      let cropH = this.$refs.vueCropperAngle.cropH;
      this.rotateStart();
      this.$refs.vueCropperAngle.rotateRight();
      this.$nextTick(() => {
        this.rotateEnd();
        //this.$refs.vueCropperAngle.cropX = cropY;
        //this.$refs.vueCropperAngle.cropY = cropX;
        this.$refs.vueCropperAngle.cropW = cropH;
        this.$refs.vueCropperAngle.cropH = cropW;
      });
    },
    getCropperFile() {
      return new Promise((resolve, reject) => {
        this.getCropChecked((blob) => {
          let newFile = blob;
          let nameArray = this.cropperOption.imgUrl
            .substring(this.cropperOption.imgUrl.lastIndexOf("/") + 1)
            .split(".");
          newFile.name = nameArray[0] + "_cut." + nameArray[1];
          resolve(newFile);
        });
      });
    },
    base64ToBlob(base64Data) {
      const arr = base64Data.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    async getCropChecked(callback) {
      let _this = this.$refs.vueCropperAngle;
      let canvasRotate = await this.applyRotation();
      // canvasRotate.toBlob((blob) => {
      //   console.log(URL.createObjectURL(blob));
      // }, "image/png");
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let width = Math.round(_this.cropW);
      let height = Math.round(_this.cropH);
      let imgRect = document
        .getElementsByClassName("cropper-box-canvas")[0]
        .getBoundingClientRect();
      let cropRect = document
        .getElementsByClassName("cropper-crop-box")[0]
        .getBoundingClientRect();
      let dx = cropRect.x - imgRect.x;
      let dy = cropRect.y - imgRect.y;
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(canvasRotate, dx, dy, width, height, 0, 0, width, height);
      ctx.restore();
      canvas.toBlob(
        (blob) => {
          //console.log(URL.createObjectURL(blob));
          callback(blob);
        },
        "image/" + _this.outputType,
        _this.outputSize
      );
    },
    applyRotation() {
      return new Promise((resolve, reject) => {
        let _this = this.$refs.vueCropperAngle;
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        // 设置 canvas 的大小以适应旋转后的图片
        let radians = (this.cropperOption.rotateAngle * Math.PI) / 180;
        let sin = Math.abs(Math.sin(radians));
        let cos = Math.abs(Math.cos(radians));
        let trueWidth = _this.trueWidth;
        let trueHeight = _this.trueHeight;
        let imgW = trueWidth * _this.scale;
        let imgH = trueHeight * _this.scale;
        canvas.width = imgW * cos + imgH * sin;
        canvas.height = imgW * sin + imgH * cos;
        let img = new Image();
        img.src = _this.imgs;
        img.onload = () => {
          // 旋转图片
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(radians);
          ctx.drawImage(img, -imgW / 2, -imgH / 2, imgW, imgH);
          ctx.restore();
          resolve(canvas);
        };
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/VueCropperAngle.vue